import(/* webpackMode: "eager" */ "/vercel/path0/app/bulk-image-editor/page.tsx");
